var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoProvider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41524 0.395136C8.79636 0.277997 9.20388 0.277997 9.585 0.395136L12.5707 1.3128C14.1284 1.79155 15.6077 2.49541 16.9617 3.40207C18.0149 4.10725 17.5157 5.75 16.2482 5.75H1.75203C0.484579 5.75 -0.0146193 4.10726 1.03853 3.40207C2.39257 2.49541 3.87186 1.79155 5.4295 1.31281L8.41524 0.395136ZM9.14432 1.82894C9.05035 1.80006 8.94988 1.80006 8.85592 1.82894L5.87018 2.74661C4.68938 3.10953 3.55803 3.61457 2.50081 4.25H15.4994C14.4422 3.61457 13.3109 3.10953 12.1301 2.74661L9.14432 1.82894Z",
    fill: "#A2A2A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25012 19C1.25012 18.5858 1.58591 18.25 2.00012 18.25H16.0001C16.4143 18.25 16.7501 18.5858 16.7501 19C16.7501 19.4142 16.4143 19.75 16.0001 19.75H2.00012C1.58591 19.75 1.25012 19.4142 1.25012 19Z",
    fill: "#A2A2A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25012 15C3.25012 15.4142 3.58591 15.75 4.00012 15.75C4.41434 15.75 4.75012 15.4142 4.75012 15L4.75012 9C4.75012 8.58579 4.41434 8.25 4.00012 8.25C3.58591 8.25 3.25012 8.58579 3.25012 9L3.25012 15Z",
    fill: "#A2A2A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00012 15.75C8.58591 15.75 8.25012 15.4142 8.25012 15L8.25012 9C8.25012 8.58579 8.58591 8.25 9.00012 8.25C9.41434 8.25 9.75012 8.58579 9.75012 9V15C9.75012 15.4142 9.41434 15.75 9.00012 15.75Z",
    fill: "#A2A2A2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2501 15C13.2501 15.4142 13.5859 15.75 14.0001 15.75C14.4143 15.75 14.7501 15.4142 14.7501 15V9C14.7501 8.58579 14.4143 8.25 14.0001 8.25C13.5859 8.25 13.2501 8.58579 13.2501 9V15Z",
    fill: "#A2A2A2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoProvider);
export default __webpack_public_path__ + "static/media/ico-provider.c0f9b8972173081f40816392ac0a892f.svg";
export { ForwardRef as ReactComponent };